export default __webpack_public_path__ + "static/media/mer_n.59a14bed.png";